import { render, staticRenderFns } from "./DoctorIndexModal.vue?vue&type=template&id=51f46b3d&scoped=true&"
import script from "./DoctorIndexModal.vue?vue&type=script&lang=js&"
export * from "./DoctorIndexModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorIndexModal.vue?vue&type=style&index=0&id=51f46b3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f46b3d",
  null
  
)

export default component.exports